module.exports = __webpack_public_path__ + "img/ERP_swiperTab_bg3.9454d711.png";